<template>
  <WdsTooltip :global="tableGlobals">
    <template #tooltip-content>
      <template v-if="totalPendingPaymentRequests > 0">
        {{
          $tc(
            ':pending payment request is awaiting approval | :pending payment requests are awaiting approval',
            totalPendingPaymentRequests,
            {
              pending: totalPendingPaymentRequests,
            },
          )
        }}
      </template>
      <template v-else>
        <template v-if="paymentRequests.length > 0">
          {{ $t('No payment requests are awaiting approval') }}
        </template>
        <template v-else>
          {{ $t('No payment requests yet') }}
        </template>
      </template>
    </template>

    <WdsTag class="tw-whitespace-nowrap" :warning md>
      <span v-if="warning" class="tw-pr-1">&#x2022;</span>
      <span class="tw-font-semibold">
        {{ totalPendingPaymentRequests > 0 ? `(${totalPendingPaymentRequests})` : '' }}
        {{ paymentRequests.length }}
      </span>
    </WdsTag>
  </WdsTooltip>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsTag, WdsTooltip } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t, $tc } from '@/app-bootstrapping/SetUpInternationalization'
import { PaymentRequestWorkerStatus } from '@/gql/graphql'
import { useTableGlobalsSelector } from '@/components/GraphqlDataTable/injection'

const tableGlobals = useTableGlobalsSelector()

const PaymentRequestSpecification = graphql(`
  fragment PaymentRequestSpecification on PaymentRequest {
    id
    workerStatus
  }
`)

const HirePaymentRequestColumn = graphql(`
  fragment HirePaymentRequestColumn on Hire {
    id

    paymentRequests(first: 100000, page: 1) {
      data {
        ...PaymentRequestSpecification
      }
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof HirePaymentRequestColumn> }>()
const column = computed(() => useFragment(HirePaymentRequestColumn, props.row))

const paymentRequests = computed(() =>
  column.value?.paymentRequests?.data
    ?.map((request) => useFragment(PaymentRequestSpecification, request))
    ?.filter((request) => request.workerStatus !== PaymentRequestWorkerStatus.Draft),
)

const totalPendingPaymentRequests = computed(
  () =>
    paymentRequests.value.filter(
      (request) => request.workerStatus === PaymentRequestWorkerStatus.Requested,
    ).length,
)

const warning = computed(() => totalPendingPaymentRequests.value > 0)
</script>
